import React from 'react'
import { Updater, async, fromJSX, Widget } from 'widgets-for-react'
import { ActualityPageData } from '../../sharepointPageApi/types/pageData'
import { RelatedActualitiesBlock } from '../blocksState'
import { RelatedActualitiesBlockLayout } from './relatedActualitiesBlockLayout'
import { RelatedActualitiesBlockState } from './relatedActualitiesBlockState'

export const relatedActualitiesBlockWidget = (
  block: RelatedActualitiesBlock
): Widget<Updater<RelatedActualitiesBlockState>> =>
  async<ActualityPageData[]>(block.relatedActualitiesState, items =>
    fromJSX(() => <RelatedActualitiesBlockLayout {...block} items={items} />)
  )
